// extracted by mini-css-extract-plugin
export var header = "_x9-1";
export var maskBottom = "_x9-6";
export var maskMiddle = "_x9-7";
export var maskTop = "_x9-5";
export var root = "_x9-0";
export var scrollDownButton = "_x9-3";
export var scrollDownButtonHidden = "_x9-4";
export var viewport = "_x9-2";